import { defineMessages } from "react-intl";

export default defineMessages({
    inventory: {
        id: "components__inventory__label",
        defaultMessage: "Inventory",
    },
});
